import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Collection = styled.ul`
  list-style: none;
  margin: -1rem 0;

  &.app-banner {
    li {
      width: 100%;
    }
  }

  li:not(:first-child) {
    margin-top: 0;
  }

  li {
    display: inline-table;
    width: 100%;
    margin: 0 0 2rem;

    p {
      display: table-cell;
      width: 100%;
      vertical-align: middle;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      width: 50%;
    }

    &.rates {
      width: 100%;
      @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
        width: 50%;
        padding-right: 0.5rem;

        &:nth-child(2n) {
          padding-right: 0;
          padding-left: 0.5rem;
        }
      }

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        padding: 0 1rem 0 0;
        width: 50%;
      }

      span {
        font-size: 3.25rem;
        font-weight: ${themeGet('fontWeights.medium')};
        line-height: 1.08;
        letter-spacing: -0.31px;

        @media only screen and (max-width: ${themeGet('breakpoints.xlg')}) {
          font-size: 2.625rem;
        }
      }

      p {
        display: block;
        clear: both;
        font-size: 1rem;
        line-height: 1.5;
      }
    }
  }

  &.interests {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 70%;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 100%;
    }

    li {
      width: 65%;

      p {
        display: block;
        font-size: 1rem;
        line-height: 150%;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
        padding-right: 0;
        padding-left: 0;
        &:nth-child(2n) {
          padding-right: 0;
          padding-left: 0;
        }
      }

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        width: 50%;
        padding: 0 2rem 0 0;
        &:nth-child(2n) {
          padding: 0 2rem 0 0;
        }
      }

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        width: 33%;
      }

      span {
        font-size: 2rem;
        font-weight: ${themeGet('fontWeights.medium')};
        line-height: 130%;
        letter-spacing: -0.25px;

        @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
          font-size: 42px;
          line-height: 120%;
          letter-spacing: -0.31px;
        }
      }
    }
  }
`;

export const Icon = styled.img`
  display: inline-flex;
  vertical-align: middle;
  width: 54px;
  margin-right: 0.75rem;

  ${Collection}.card-features & {
    margin-bottom: 1rem;
    margin-right: 0;
    width: 30px;

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin-bottom: 1.25rem;
      width: 54px;
    }
  }
`;
